import { lazy, memo } from 'react';

const Login = lazy(() => import(/* webpackChunkName: "login" */ 'ni-login'));

const AccountWidget = () => {
  return <Login />;
};

export default memo(AccountWidget);
